export default "__VITE_ASSET__BOrkY4NU__"